.b7{justify-content:flex-end;}